<template>
	<div>
		<modalconfirm ref="modalApprovalTO" @action="proccessTO"/>
		<div class="text-h5">{{$route.meta.title}}</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-form>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-autocomplete :items="TOforApprove" v-model="to_code" item-value="to_code" @change="getDetail(to_code)" label="Transfer Stok" no-data-text="Tidak ada data yang sesuai" outlined dense @focus="responseError.to_id = ''" :error-messages="responseError.to_id" hide-details="auto" class="width-0">
								<template v-slot:item = {item}>
									{{ item.to_code }} - {{ item.warehouse_name }}
								</template>
								<template v-slot:selection = {item}>
									{{ item.to_code }}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" v-if="Object.keys(detailTO).length > 0">
							<div class="font-weight-bold">Detail Warehouse</div>
							<v-row>
								<v-col cols="6" sm="6" md="2">
									<div class="d-flex">
										<v-icon>mdi-warehouse</v-icon>
										<div class="pl-3">{{ detailTO.warehouse_from.warehouse_name }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="6" md="2">
									<div class="d-flex">
										<v-icon>mdi-phone</v-icon>
										<div class="pl-3">{{ detailTO.warehouse_from.warehouse_mobilephone }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="6" md="4">
									<div class="d-flex">
										<v-icon class="icon-align-top">mdi-map-marker</v-icon>
										<div class="pl-3">{{ addresText }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="6" md="4">
									<div class="d-flex">
										Catatan:
										<div class="pl-3">{{ detailTO.to_note }}</div>
									</div>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-data-table disable-pagination :headers="headers" :items="detailTO.to_detail" hide-default-footer class="" no-data-text="Tidak ada data tersedia">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.to_detail_product_name }}</div>
								</template>
								<template v-slot:item.product_code="{ item }">
									<div class="pt-2">{{ item.to_detail_product_code }}</div>
								</template>
								<template v-slot:item.quantity="{ item }">
									<div class="pt-2">{{ item.to_detail_quantity_requested | toNumber }}</div>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" :disabled="!to_code" outlined class="ml-2 text-capitalize" @click="reject">Tolak</v-btn>
				<v-btn color="primary darken-1" :disabled="!to_code" depressed class="ml-2 text-capitalize" @click="approve">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			to_code: '',
			toProccess: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Jumlah Permintaan', value: 'quantity', align: 'end'},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('to', ['detailTO', 'response', 'responseError', 'TOforApprove']),

		addresText() {
			var data = []
			if (this.detailTO.warehouse_from) {
				if (this.detailTO.warehouse_from.warehouse_address)
					data.push(this.detailTO.warehouse_from.warehouse_address)
				if (this.detailTO.warehouse_from.warehouse_subdistrict_name)
					data.push(this.detailTO.warehouse_from.warehouse_subdistrict_name)
				if (this.detailTO.warehouse_from.warehouse_city_name)
					data.push(this.detailTO.warehouse_from.warehouse_city_name)
				if (this.detailTO.warehouse_from.warehouse_province_name)
					data.push(this.detailTO.warehouse_from.warehouse_province_name)
			}
			return data.join(', ')
		}
	},
	methods: {
		...mapActions('to', ['getDetailTO', 'approvalAdminTO', 'approveTO', 'rejectTO', 'getOptionTOforApprove']),
		...mapMutations('to', ['setDetailTO', 'saveResponse']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailTO(code)
			} else {
				this.setDetailTO({})
			}
		},
		approve(){
			this.toProccess = 'approve'
			let msg = "Yakin akan memproses Transfer Stok ini?"
			this.$refs.modalApprovalTO.setMessage(msg)
			this.$refs.modalApprovalTO.showConfirm()
		},
		reject(){
			this.toProccess = 'reject'
			let msg = "Yakin akan menolak Transfer Stok ini?"
			this.$refs.modalApprovalTO.setMessage(msg)
			this.$refs.modalApprovalTO.showConfirm()
		},
		async proccessTO() {
			await this.setOverlay(true)
			await this.$refs.modalApprovalTO.hideConfirm()
      if (this.$route.name == 'approval-transfer-stock-admin') {
        await this.approvalAdminTO({
          to_id: this.detailTO.to_id,
          status: this.toProccess == 'approve' ? 'approved_admin' : 'rejected_admin',
        }).then(() => {
          if (this.response.code == 200.) {
            this.resetForm()
          }
        })

      } else {
        if (this.toProccess == 'approve') {
          await this.approveTO(this.detailTO.to_id).then(() => {
            if (this.response.code == 200.) {
              this.resetForm()
            }
          })
        } else if (this.toProccess == 'reject') {
          await this.rejectTO(this.detailTO.to_id).then(() => {
            if (this.response.code == 200.) {
              this.resetForm()
            }
          })
        }
      }

			await this.setOverlay(false)
		},
		resetForm() {
			this.saveResponse({})
			this.to_code = ''
			this.setDetailTO({})
			if(this.$route.name == 'approval-transfer-stock-admin') {
        this.getOptionTOforApprove('admin')
      } else {
        this.getOptionTOforApprove('rdc')
      }
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Approval Transfer Stok`)
		if(this.$route.name == 'approval-transfer-stock-admin') {
      this.getOptionTOforApprove('admin')
    } else {
      this.getOptionTOforApprove('rdc')
    }
		if (this.$route.params.code) {
			this.to_code = this.$route.params.code
			this.getDetailTO(this.$route.params.code)
		}
	},
	watch: {
	}
}
</script>
